import { Link } from 'react-router-dom';
import { BrandLogo, Text } from '@scale/scaleui-radix';
import { LayoutHeader } from './layout';
import { GenAIOpsHubPaths } from '../constants';
import { useHolidayMode } from '../holidays/useHolidayMode';
import { HolidayScaleLogo } from '../holidays/HolidayScaleLogo';

const CorpProjectGroupManagerHomeHeader = () => {
  const holidayMode = useHolidayMode();

  return (
    <>
      <Link
        to={GenAIOpsHubPaths.Main}
        className="flex gap-3 items-center whitespace-nowrap h-full w-1/3"
      >
        {holidayMode?.holiday === 'CHRISTMAS' ? (
          <HolidayScaleLogo />
        ) : (
          <BrandLogo color="gradient" size="4" />
        )}
        <Text
          size="5"
          className="text-[#152031] text-[20px] font-medium font-inter leading-[28px] tracking-[-0.08px] w-[146px]"
        >
          GenAI Ops Hub
        </Text>
      </Link>
      <LayoutHeader noBorder />
    </>
  );
};

export { CorpProjectGroupManagerHomeHeader };
